module.exports = __webpack_public_path__ + "img/bkg.85abd5ff.png";